import { IExportDownloadResponse, IExportTasksResponse } from 'shared';

import { orgHeader } from '../../../../common/lib/axiosBaseQuery';
import { emptySplitApi } from '../baseApi';
import { CacheTags } from '../../types/cacheTags';

export const exportsApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    fetchExportTasks: builder.query<IExportTasksResponse, { organisationId: string }>({
      query: ({ organisationId }) => ({
        url: `exports`,
        method: `GET`,
        headers: { [orgHeader]: organisationId },
      }),
      providesTags: [{ type: CacheTags.ExportTasks, id: `LIST` }],
    }),
    fetchScheduledExportTasks: builder.query<IExportTasksResponse, { organisationId: string }>({
      query: ({ organisationId }) => ({
        url: `exports/scheduled`,
        method: `GET`,
        headers: { [orgHeader]: organisationId },
      }),
      providesTags: [{ type: CacheTags.ExportTasks, id: `SCHEDULED` }],
    }),
    fetchExportDownloadUrl: builder.query<IExportDownloadResponse, { organisationId: string; id: number }>({
      query: ({ organisationId, id }) => ({
        url: `exports/${id}/download`,
        method: `GET`,
        headers: { [orgHeader]: organisationId },
      }),
    }),
  }),
});

export const {
  useFetchExportTasksQuery,
  useFetchScheduledExportTasksQuery,
  useLazyFetchExportDownloadUrlQuery,
} = exportsApi;
